import remoteConfig from '@/lib/remote-config'

export default {
  computed: {
    remoteConfig() {
      return remoteConfig
    }
  }
}
